import React from "react";
import "./style.css";
import warning from "../assets/info.png";
import success from "../assets/tick.png";
import error from "../assets/warning.png";


export default function PopUp({ type, title, description }) {
  const popUps = [
    {
      type: "error",
      background:
        "linear-gradient(0deg, rgba(255,62,61,0) 0%, rgba(255,62,61,0.4459033613445378) 100%)",
      svg: error,
      shadow: "rgba(255, 62, 61, 0.3) 0px 4px 12px",
    },
    {
      type: "warning",
      background:
        "linear-gradient(0deg, rgba(255, 180, 72,0) 0%, rgba(255, 180, 72,0.4459033613445378) 100%)",
      svg: warning
       
      ,
      shadow: "rgba(255, 180, 72, 0.3) 0px 4px 12px",
    },
    {
      type: "success",
      background:
        "linear-gradient(0deg, rgba(82, 202, 153,0) 0%, rgba(82, 202, 153,0.4459033613445378) 100%)",
      svg:success,
      shadow: "rgba(82, 202, 153, 0.3) 0px 4px 12px",
    },
  ];

  // Find the popUp configuration based on the `type` prop
  const popUp = popUps.find((pop) => pop.type === type) || popUps[0];

  return (
    <div
      className="snackbar"
      style={{
        background: popUp.background,
       
        border: "2px solid #fff",
      }}
    >
      <div className="icon" style={{ boxShadow: popUp.shadow}}>

      <img src={popUp.svg} alt="" srcset="" />

      </div>
      <div className="snackBarContent">
        <p className="title">{title}</p>
        <p className="description">{description}</p>
      </div>
    </div>
  );
}
